module.exports = __webpack_public_path__ + "img/doc-file-format.a4a7b338.svg";